<p-dialog
	[(visible)]="visible"
	[dismissableMask]="true"
	[modal]="true"
	[style]="{ width: '25rem' }"
	[draggable]="false"
>
	<div class="error-icon-container">
		<i class="pi pi-exclamation-circle error-icon"></i>
	</div>
	<h2 class="dialog-title">{{ title }}</h2>
	<p class="dialog-description">{{ description }}</p>
</p-dialog>
